__webpack_require__.p = "/wp-content/themes/verastem-2024/dist/";